class LinkList extends HTMLElement {
  constructor() {
    super();
    this.breakpoint = this.dataset.breakPoint
      ? parseInt(this.dataset.breakPoint)
      : 800;
    this.header = this.querySelector(".header");
    this.content = this.querySelector(".content");
    if (this.header && this.content) {
      this.header.addEventListener("click", this.toggleContent.bind(this));
    }
  }

  toggleContent() {
    if (window.innerWidth >= this.breakpoint) return;
    this.toggleAttribute("open");
  }
}
customElements.define("link-list", LinkList);
